import React, { useState } from "react";

export const TooltipIcon = ({ text, position = 'right' }) => {
    const pos = position === 'top'
        ? 'bottom-full mb-2 left-1/2 -translate-x-1/2'
        : 'left-full ml-2 top-1/2 -translate-y-1/2';

    return (
        <div
            className="relative inline-flex items-center group"
        >
            <span
                className="flex items-center justify-center w-5 h-5 rounded-full bg-[#2B3135] text-white/80 text-xs select-none"
                aria-label="Подробнее"
            >
                ?
            </span>
            <div
                className={`absolute z-20 hidden group-hover:block ${pos} pointer-events-none`}
                style={{ minWidth: "260px", maxWidth: "460px" }}
            >
                <div className="rounded-lg bg-[#2B3135] text-white border border-white/[12%] shadow-lg p-3 text-[12px] leading-[16px]">
                    {text}
                </div>
            </div>
        </div>
    );
};


